import { groupAssociationChanged } from 'owa-calendar-cache';
import { initializeGroupCalendars } from '../utils/initializeGroupCalendars';
import { orchestrator } from 'satcheljs';
import { trace } from 'owa-trace';
import debounce from 'lodash-es/debounce';
import { getUserMailboxInfo } from 'owa-client-ids';

let debouncedRefreshGroupCalendars = null;

// Respond to changes to group membership by refreshing the set of group calendars.
// When a group calendar is created or removed we get multiple row-modified notifications and they
// might be a couple of seconds apart, so we debounce to avoid hitting the server multiple times.
orchestrator(groupAssociationChanged, ({ payload: { id, EventType, Group } }) => {
    trace.info(`${id}: ${EventType}, ${Group?.SmtpAddress}`);
    if (!debouncedRefreshGroupCalendars) {
        debouncedRefreshGroupCalendars = debounce(
            initializeGroupCalendars.bind(null, getUserMailboxInfo().userIdentity, true),
            2000
        );
    }
    debouncedRefreshGroupCalendars();
});
